export default __webpack_public_path__ + "static/media/btn_infos_collaborateurs.89c8b0ba.svg";